// Shared helpers for tour step travel origin resolution.

import {
  queryFireflyTargetById,
  readFireflyTargetRect,
} from "@/lib/firefly/fireflyTargetConvention";

export const FIREFLY_TOUR_DOCK_ANCHOR_IDS = new Set([
  "send-all-unsent",
  "unsent-leads-section",
  "sent-leads-section",
  "ask-firefly",
  "sc-daily-checklist",
  "ads-activity-coaching",
]);

export function resolveFireflyTourTravelOrigin(targetId: string): { x: number; y: number } {
  const dockTab = queryFireflyTargetById("activity-dock-tab");
  if (dockTab) {
    const rect = readFireflyTargetRect(dockTab);
    return { x: rect.centerX, y: rect.centerY };
  }
  const el = queryFireflyTargetById(targetId);
  if (el) {
    const rect = readFireflyTargetRect(el);
    return { x: rect.centerX, y: rect.centerY };
  }
  return {
    x: typeof window !== "undefined" ? window.innerWidth * 0.5 : 0,
    y: typeof window !== "undefined" ? window.innerHeight * 0.5 : 0,
  };
}
